function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useConfirmation } from '@signicat/designi/components/overlays';
import { Button } from '@signicat/designi/components/buttons';
import { Autocomplete, Toggle, Select, TextField } from '@signicat/designi/components/inputs';
import { Form, Field } from '@signicat/designi/components/forms';
import { Message } from '@signicat/designi/components/messages';
import { Grid, Flex, Row, Column } from '@signicat/designi/components/layout';
import { Spinner } from '@signicat/designi/components/loaders';
import { Segment } from '@signicat/designi/components/containers';
import { Icon } from '@signicat/designi/components/icons';
import { Heading, Paragraph } from '@signicat/designi/components/text';
import { media } from '@signicat/designi/helpers/responsive';
import { req, download } from '@signiapp/helpers/api';
import { Tooltip } from '@signicat/designi/components/overlays';
import { Feature } from '@signiapp/core/components';
import { create, orders as ordersActions } from "../../store/actions";
import { groupsSelector } from "../../store/selectors/signature";
import { t } from "../../helpers/i18n";
import Upload from "./content/Upload";
var RepairButton = styled(Button).withConfig({
  displayName: "Content__RepairButton",
  componentId: "sc-b1ollr-0"
})(["margin-bottom:10px;max-width:300px;min-width:200px;"]);
var RepairAlert = styled(Message).withConfig({
  displayName: "Content__RepairAlert",
  componentId: "sc-b1ollr-1"
})(["flex-direction:column;"]);
var MobileFileEl = styled(Flex).withConfig({
  displayName: "Content__MobileFileEl",
  componentId: "sc-b1ollr-2"
})(["width:100%;border-top:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;flexwrap:wrap;margin:0;position:relative;"]);
var StyledTable = styled('table').withConfig({
  displayName: "Content__StyledTable",
  componentId: "sc-b1ollr-3"
})(["border-collapse:collapse;width:calc(100% - 2px);thead{th{text-align:left;padding:12px 0px;z-index:999;border-bottom:1px solid #dfdbd6;color:#190147;}}tbody{border-left:2px solid #dfdbd6;border-right:1px solid #dfdbd6;tr{border-top:1px solid #dfdbd6;border-bottom:1px solid #dfdbd6;}}tbody td{&:nth-child(1){width:32px;}&:nth-child(2){width:230px;}&:nth-last-child(1){text-align:right;padding-right:23px;width:32px;}&:nth-last-child(2){text-align:right;}}"]);
var RemoveIcon = styled(Icon).withConfig({
  displayName: "Content__RemoveIcon",
  componentId: "sc-b1ollr-4"
})(["transition:all 0.2s;border-radius:4px;&:hover{background-color:rgba(0,0,0,0.2);}"]);
var SpinnerBackground = styled(Flex).withConfig({
  displayName: "Content__SpinnerBackground",
  componentId: "sc-b1ollr-5"
})(["position:fixed;top:0;left:0;right:0;bottom:0;align-items:center;justify-content:center;backdrop-filter:blur(4px);z-index:4;"]);
var Content = function Content(props) {
  var _order$uiFeatures;
  var dispatch = useDispatch();
  var confirm = useConfirmation();

  // Get state from store
  var _useSelector = useSelector(function (state) {
      return state.session;
    }),
    access = _useSelector.access;
  var _useSelector2 = useSelector(function (state) {
      return state.create;
    }),
    order = _useSelector2.data;
  var _useState = useState([].concat(_toConsumableArray(order.documents.map(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        category: 'document'
      });
    })), _toConsumableArray(order.attachments.map(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        category: 'attachment'
      });
    })))),
    _useState2 = _slicedToArray(_useState, 2),
    files = _useState2[0],
    setFiles = _useState2[1];
  var userAndOrderGroups = useSelector(groupsSelector).filter(function (group) {
    var _access$groups, _order$permissions, _order$permissions$gr;
    return (access === null || access === void 0 ? void 0 : (_access$groups = access.groups) === null || _access$groups === void 0 ? void 0 : _access$groups.includes(group.group)) || ((_order$permissions = order.permissions) === null || _order$permissions === void 0 ? void 0 : (_order$permissions$gr = _order$permissions.groups) === null || _order$permissions$gr === void 0 ? void 0 : _order$permissions$gr.includes(group.group));
  });
  var _useSelector3 = useSelector(function (state) {
      return state.create;
    }),
    fileUploadErrors = _useSelector3.fileUploadErrors;
  var _useSelector4 = useSelector(function (state) {
      return state.create;
    }),
    uploads = _useSelector4.uploads;
  var attachments = order.attachments,
    documents = order.documents;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isUploading = _useState4[0],
    setIsUploading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isRepairing = _useState6[0],
    setIsRepairing = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    privateOrderEnabled = _useState8[0],
    setPrivateOrderEnabled = _useState8[1];
  var _useState9 = useState(true),
    _useState10 = _slicedToArray(_useState9, 2),
    orderGroupsEnabled = _useState10[0],
    setOrderGroupsEnabled = _useState10[1];
  var _useState11 = useState(files.reduce(function (a, b) {
      a[b.id] = b.title;
      return a;
    }, {})),
    _useState12 = _slicedToArray(_useState11, 2),
    fileTitles = _useState12[0],
    setFileTitles = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    fileUnderEdit = _useState14[0],
    setFileUnderEdit = _useState14[1];
  var _useState15 = useState(null),
    _useState16 = _slicedToArray(_useState15, 2),
    hoveredFile = _useState16[0],
    setHoveredFile = _useState16[1];
  // Upload start
  var toggleLoading = function toggleLoading(value) {
    setIsUploading(value);
  };
  var setDefaultSignerRole = function setDefaultSignerRole(fileId, fileCategory) {
    dispatch({
      type: 'SET_DEFAULT_SIGNERS_ROLES',
      payload: {
        fileId: fileId,
        fileCategory: fileCategory
      }
    });
  };
  var showUploadError = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return confirm({
              message: t('file_upload_error_unknown', {
                filename: fileUploadErrors.map(function (f) {
                  return f.title;
                }).join(', ')
              }),
              variant: 'info'
            });
          case 2:
            dispatch({
              type: 'REMOVE_FAILED_UPLOADS'
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function showUploadError() {
      return _ref.apply(this, arguments);
    };
  }();
  // Actions triggered from list
  var removeFile = function removeFile(id, category) {
    return function () {
      dispatch(ordersActions.removeFile(order.id, id, category));
      dispatch(ordersActions.removeFileSignerRole(id));
      // TODO: Handle errors
    };
  };
  var userId = useSelector(function (state) {
    return state.session.user.userId;
  });
  var users = useSelector(function (state) {
    return state.create.data.permissions.users;
  });
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    isDefaultPrivate = _useState18[0],
    setIsDefaultPrivate = _useState18[1];
  var isPrivateOrder = useSelector(function (state) {
    var _state$create$data$pe, _state$create$data$pe2;
    return privateOrderEnabled && Boolean(((_state$create$data$pe = state.create.data.permissions) === null || _state$create$data$pe === void 0 ? void 0 : (_state$create$data$pe2 = _state$create$data$pe.users) === null || _state$create$data$pe2 === void 0 ? void 0 : _state$create$data$pe2.indexOf(state.session.user.userId)) > -1);
  });
  var errorsDetected = function errorsDetected(docs) {
    var _docs$filter;
    return (docs === null || docs === void 0 ? void 0 : (_docs$filter = docs.filter(function (d) {
      var _d$validationResult$f, _d$validationResult;
      return !((_d$validationResult$f = d === null || d === void 0 ? void 0 : (_d$validationResult = d.validationResult) === null || _d$validationResult === void 0 ? void 0 : _d$validationResult.fileIsValid) !== null && _d$validationResult$f !== void 0 ? _d$validationResult$f : true);
    })) === null || _docs$filter === void 0 ? void 0 : _docs$filter.length) > 0;
  };
  var filesHasBeenFixed = function filesHasBeenFixed(docs) {
    var _docs$filter2;
    return docs && ((_docs$filter2 = docs.filter(function (d) {
      var _d$validationResult2, _d$validationResult3;
      return (d === null || d === void 0 ? void 0 : (_d$validationResult2 = d.validationResult) === null || _d$validationResult2 === void 0 ? void 0 : _d$validationResult2.fileIsValid) && (d === null || d === void 0 ? void 0 : (_d$validationResult3 = d.validationResult) === null || _d$validationResult3 === void 0 ? void 0 : _d$validationResult3.wasRepairedBySigniapp);
    })) === null || _docs$filter2 === void 0 ? void 0 : _docs$filter2.length) > 0;
  };
  var fileAsyncErrorExistsOnOrder = function fileAsyncErrorExistsOnOrder() {
    var _order$asyncErrors, _order$asyncErrors$fi;
    return ((documents === null || documents === void 0 ? void 0 : documents.length) > 0 || (attachments === null || attachments === void 0 ? void 0 : attachments.length) > 0) && ((_order$asyncErrors = order.asyncErrors) === null || _order$asyncErrors === void 0 ? void 0 : (_order$asyncErrors$fi = _order$asyncErrors.filter(function (error) {
      return error.title === 'pdf_invalid_title';
    })) === null || _order$asyncErrors$fi === void 0 ? void 0 : _order$asyncErrors$fi.length) > 0;
  };
  var handleRepairAllFilesClick = function handleRepairAllFilesClick() {
    setIsRepairing(true);
    if ((documents === null || documents === void 0 ? void 0 : documents.length) > 0) {
      for (var i = 0; i < documents.length; i++) {
        var _documents$i$validati, _documents$i$validati2;
        if (!((_documents$i$validati = (_documents$i$validati2 = documents[i].validationResult) === null || _documents$i$validati2 === void 0 ? void 0 : _documents$i$validati2.fileIsValid) !== null && _documents$i$validati !== void 0 ? _documents$i$validati : true)) {
          dispatch(ordersActions.repairFile(order.id, documents[i].id, 'document'));
        }
      }
    }
    if ((attachments === null || attachments === void 0 ? void 0 : attachments.length) > 0) {
      for (var _i = 0; _i < attachments.length; _i++) {
        var _attachments$_i$valid, _attachments$_i$valid2;
        if (!((_attachments$_i$valid = (_attachments$_i$valid2 = attachments[_i].validationResult) === null || _attachments$_i$valid2 === void 0 ? void 0 : _attachments$_i$valid2.fileIsValid) !== null && _attachments$_i$valid !== void 0 ? _attachments$_i$valid : true)) {
          dispatch(ordersActions.repairFile(order.id, attachments[_i].id, 'attachment'));
        }
      }
    }
  };
  var handleIsPrivateOrderChange = function handleIsPrivateOrderChange(e) {
    dispatch(create.setPrivate(!isPrivateOrder));
    dispatch({
      type: 'ORDER_SET_PERMISSIONS_GROUPS',
      groups: []
    });
  };
  var handleGroupsChange = function handleGroupsChange(e, newValue) {
    dispatch({
      type: 'ORDER_SET_PERMISSIONS_GROUPS',
      groups: newValue
    });
  };
  var handleFileChange = function handleFileChange(parameter, fileId) {
    return function (e) {
      var value = e.target.value;
      if (parameter === 'type') setDefaultSignerRole(fileId, value);
      dispatch(create.editFile(order.id, fileId, parameter, value));
      if (parameter === 'title') setFileUnderEdit(null);
    };
  };
  var handleFileTitleChange = function handleFileTitleChange(fileId) {
    return function (e) {
      var value = e.target.value;
      setFileTitles(_objectSpread(_objectSpread({}, fileTitles), {}, _defineProperty({}, fileId, value)));
    };
  };
  var showPrivateWarning = function showPrivateWarning() {
    var _order$permissions2, _order$permissions3, _order$permissions4, _order$permissions4$g;
    return isPrivateOrder && ((_order$permissions2 = order.permissions) === null || _order$permissions2 === void 0 ? void 0 : _order$permissions2.allowedPortalAdminAccessLevel) === 'FullAccess' || ((_order$permissions3 = order.permissions) === null || _order$permissions3 === void 0 ? void 0 : _order$permissions3.allowedPortalAdminAccessLevel) !== 'NormalUserAccess' && ((_order$permissions4 = order.permissions) === null || _order$permissions4 === void 0 ? void 0 : (_order$permissions4$g = _order$permissions4.groups) === null || _order$permissions4$g === void 0 ? void 0 : _order$permissions4$g.length) > 0;
  };
  var downloadFile = function downloadFile(doc) {
    return function () {
      var _doc$urls;
      if (doc !== null && doc !== void 0 && (_doc$urls = doc.urls) !== null && _doc$urls !== void 0 && _doc$urls.unsigned) {
        req(doc.urls.unsigned).then(function (json) {
          return download(json.url, {
            filename: doc.filename
          });
        })["catch"](function (err) {
          alert('Could not download the requested file due to an error.');
          console.error(err);
        });
      }
    };
  };
  var errorsFound = errorsDetected(documents) || errorsDetected(attachments);
  var errorAlert = errorsFound ? /*#__PURE__*/React.createElement(RepairAlert, {
    variant: "error"
  }, /*#__PURE__*/React.createElement(Paragraph, null, t('signorder_section_documents_errors'), " "), /*#__PURE__*/React.createElement(Flex, {
    direction: "row",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    width: "100%"
  }, /*#__PURE__*/React.createElement(RepairButton, {
    disabled: isRepairing,
    onClick: function onClick() {
      return handleRepairAllFilesClick();
    },
    color: "secondary"
  }, isRepairing ? /*#__PURE__*/React.createElement(Spinner, null) : t('button_text_repair_all')))) : null;
  var isFileInvalid = function isFileInvalid(file) {
    var _file$validationResul, _file$validationResul2;
    return !((_file$validationResul = (_file$validationResul2 = file.validationResult) === null || _file$validationResul2 === void 0 ? void 0 : _file$validationResul2.fileIsValid) !== null && _file$validationResul !== void 0 ? _file$validationResul : true);
  };
  var isFileInfected = function isFileInfected(file) {
    return file.virusDetected;
  };
  var allFilesValidOrAttemptedFixed = function allFilesValidOrAttemptedFixed(files) {
    return !files || files.length === 0 || files.filter(function (d) {
      return (d === null || d === void 0 ? void 0 : d.validationResult) && !d.validationResult.fileIsValid && !d.validationResult.wasRepairedBySigniapp;
    }).length === 0;
  };
  var docFixAttempted = allFilesValidOrAttemptedFixed(documents);
  var attachmentFixAttempted = allFilesValidOrAttemptedFixed(attachments);
  useEffect(function () {
    if (docFixAttempted && attachmentFixAttempted) {
      setIsRepairing(false);
    }
  }, [isRepairing, docFixAttempted, attachmentFixAttempted]);
  useEffect(function () {
    setIsDefaultPrivate(Boolean(users && users.indexOf(userId) > -1));
  }, []);
  useEffect(function () {
    if (privateOrderEnabled === false) {
      dispatch({
        type: 'ORDER_SET_PERMISSIONS_USERS',
        users: null
      });
    } else if (isDefaultPrivate) {
      dispatch({
        type: 'ORDER_SET_PERMISSIONS_USERS',
        users: [userId]
      });
    }
  }, [privateOrderEnabled]);
  useEffect(function () {
    if (files.some(function (file) {
      return !fileTitles[file.id];
    })) setFileTitles(files.reduce(function (a, b) {
      a[b.id] = b.title;
      return a;
    }, {}));
  }, [files]);
  useEffect(function () {
    var files = [].concat(_toConsumableArray(order.documents.map(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        category: 'document'
      });
    })), _toConsumableArray(order.attachments.map(function (x) {
      return _objectSpread(_objectSpread({}, x), {}, {
        category: 'attachment'
      });
    })));
    setFiles(files);
  }, [order.documents, order.attachments]);
  useEffect(function () {
    if (fileUploadErrors !== null && fileUploadErrors !== void 0 && fileUploadErrors.length) showUploadError();
  }, [fileUploadErrors]);
  var flexFile = function flexFile(file, i) {
    var _file$validationResul3, _file$validationResul4, _file$validationResul5, _file$validationResul6;
    return /*#__PURE__*/React.createElement(MobileFileEl, {
      alignItems: "center",
      flexDirection: "column",
      key: i,
      style: {
        backgroundColor: !((_file$validationResul3 = (_file$validationResul4 = file.validationResult) === null || _file$validationResul4 === void 0 ? void 0 : _file$validationResul4.fileIsValid) !== null && _file$validationResul3 !== void 0 ? _file$validationResul3 : true) ? 'rgba(152, 58, 4, 0.1)' : ''
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      size: "lg",
      name: isFileInvalid(file) ? 'warning' : isFileInfected(file) ? 'error' : file.category === 'attachment' ? 'attachment' : 'description',
      style: {
        margin: '8px 0'
      },
      color: isFileInfected(file) || isFileInvalid(file) ? '#983A04' : '#717171'
    }), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement(Select, {
      onChange: handleFileChange('type', file.id),
      label: "Type",
      options: [{
        text: t('signorder_contenttype_document'),
        value: 'document'
      }, {
        text: t('signorder_contenttype_attachment'),
        value: 'attachment'
      }],
      value: file.category,
      style: {
        margin: '12px 10px 8px 0'
      }
    }), /*#__PURE__*/React.createElement(TextField, {
      onBlur: handleFileChange('title', file.id),
      onChange: handleFileTitleChange(file.id),
      label: t('signorder_field_file_name_label'),
      value: fileTitles[file.id] || '',
      style: {
        margin: '12px 0 8px',
        maxWidth: '180px'
      }
    })), ((_file$validationResul5 = file.validationResult) === null || _file$validationResul5 === void 0 ? void 0 : _file$validationResul5.wasRepairedBySigniapp) && ((_file$validationResul6 = file.validationResult) === null || _file$validationResul6 === void 0 ? void 0 : _file$validationResul6.fileIsValid) && /*#__PURE__*/React.createElement(Flex, {
      justifyContent: "space-between",
      style: {
        margin: '8px 0 16px',
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      style: {
        borderRadius: '4px',
        border: '1px solid #DFDBD6',
        padding: '6px 12px'
      }
    }, "Repaired"), /*#__PURE__*/React.createElement(Button, {
      icon: "download",
      size: "sm",
      style: {
        margin: '0 0 0 20px'
      },
      onClick: downloadFile(file),
      color: "secondary"
    }, "Check document")), /*#__PURE__*/React.createElement(RemoveIcon, {
      name: "close",
      size: "md",
      style: {
        margin: '0',
        cursor: 'pointer',
        position: 'absolute',
        top: '0',
        right: '0'
      },
      onClick: removeFile(file.id, file.category)
    }));
  };
  var tableFileEl = function tableFileEl(file, i) {
    var _file$validationResul7, _file$validationResul8, _fileTitles$file$id, _fileTitles$file$id2, _file$validationResul9, _file$validationResul10;
    return /*#__PURE__*/React.createElement("tr", {
      vertical: "center",
      key: i,
      style: {
        borderBottom: '1px solid #E0E0E0',
        backgroundColor: !((_file$validationResul7 = (_file$validationResul8 = file.validationResult) === null || _file$validationResul8 === void 0 ? void 0 : _file$validationResul8.fileIsValid) !== null && _file$validationResul7 !== void 0 ? _file$validationResul7 : true) ? 'rgba(152, 58, 4, 0.1)' : ''
      }
    }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Icon, {
      size: "lg",
      name: isFileInvalid(file) ? 'warning' : isFileInfected(file) ? 'error' : file.category === 'attachment' ? 'attachment' : 'description',
      style: {
        margin: '0 15px',
        justifyContent: 'flex-start'
      },
      color: isFileInfected(file) || isFileInvalid(file) ? '#983A04' : '#717171'
    })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Select, {
      onChange: handleFileChange('type', file.id),
      options: [{
        text: t('signorder_contenttype_document'),
        value: 'document'
      }, {
        text: t('signorder_contenttype_attachment'),
        value: 'attachment'
      }],
      value: file.category,
      style: {
        margin: '12px 40px 8px 0',
        minWidth: '170px',
        maxWidth: '230px',
        whiteSpace: 'nowrap'
      }
    })), /*#__PURE__*/React.createElement("td", null, fileUnderEdit !== file.id && (((_fileTitles$file$id = fileTitles[file.id]) === null || _fileTitles$file$id === void 0 ? void 0 : _fileTitles$file$id.length) > (filesHasBeenFixed(files) ? 35 : 70) ? /*#__PURE__*/React.createElement(Tooltip, {
      anchor: /*#__PURE__*/React.createElement("div", {
        onClick: function onClick() {
          setFileUnderEdit(file.id);
          setHoveredFile(null);
        },
        style: {
          marginLeft: '14px',
          display: 'flex',
          alignItems: 'center'
        },
        onMouseEnter: function onMouseEnter() {
          return setHoveredFile(file.id);
        },
        onMouseLeave: function onMouseLeave() {
          return setHoveredFile(null);
        }
      }, (_fileTitles$file$id2 = fileTitles[file.id]) === null || _fileTitles$file$id2 === void 0 ? void 0 : _fileTitles$file$id2.substring(0, filesHasBeenFixed(files) ? 35 : 70), "...", hoveredFile === file.id && /*#__PURE__*/React.createElement(Icon, {
        name: "edit",
        style: {
          opacity: '0.5',
          marginLeft: '4px'
        }
      })),
      arrow: true
    }, /*#__PURE__*/React.createElement("span", null, fileTitles[file.id])) : /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        setFileUnderEdit(file.id);
        setHoveredFile(null);
      },
      style: {
        marginLeft: '14px',
        display: 'flex',
        alignItems: 'center'
      },
      onMouseEnter: function onMouseEnter() {
        return setHoveredFile(file.id);
      },
      onMouseLeave: function onMouseLeave() {
        return setHoveredFile(null);
      }
    }, fileTitles[file.id], hoveredFile === file.id && /*#__PURE__*/React.createElement(Icon, {
      name: "edit",
      style: {
        opacity: '0.5',
        marginLeft: '4px'
      }
    }))), fileUnderEdit === file.id && /*#__PURE__*/React.createElement(TextField, {
      onBlur: handleFileChange('title', file.id),
      onChange: handleFileTitleChange(file.id),
      value: fileTitles[file.id] || '',
      style: {
        margin: '12px 0 8px',
        width: '95%'
      }
    })), /*#__PURE__*/React.createElement("td", null, ((_file$validationResul9 = file.validationResult) === null || _file$validationResul9 === void 0 ? void 0 : _file$validationResul9.wasRepairedBySigniapp) && ((_file$validationResul10 = file.validationResult) === null || _file$validationResul10 === void 0 ? void 0 : _file$validationResul10.fileIsValid) && /*#__PURE__*/React.createElement(Flex, {
      justifyContent: "flex-end"
    }, /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      style: {
        borderRadius: '4px',
        border: '1px solid #DFDBD6',
        padding: '6px 12px'
      }
    }, t('repaired_file_prompt')), /*#__PURE__*/React.createElement(Button, {
      icon: "download",
      size: "sm",
      style: {
        margin: '0 10px'
      },
      onClick: downloadFile(file),
      color: "secondary"
    }, t('button_text_download_repaired')))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(RemoveIcon, {
      name: "close",
      size: "md",
      style: {
        cursor: 'pointer'
      },
      onClick: removeFile(file.id, file.category)
    })));
  };
  var filesIsFixedAlert = !errorsFound && (filesHasBeenFixed(documents) || filesHasBeenFixed(attachments) || fileAsyncErrorExistsOnOrder()) ? /*#__PURE__*/React.createElement(Message, {
    variant: "info",
    icon: media.matches.tablet.and('up') ? 'check' : null
  }, t('signorder_section_documents_allfixed')) : null;
  return /*#__PURE__*/React.createElement(Form, null, isUploading && /*#__PURE__*/React.createElement(SpinnerBackground, null, /*#__PURE__*/React.createElement(Spinner, null)), /*#__PURE__*/React.createElement(Fragment, null, errorAlert, filesIsFixedAlert), files.length > 0 && /*#__PURE__*/React.createElement(Segment, {
    outlined: true,
    padding: "24px"
  }, /*#__PURE__*/React.createElement(Column, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(Column, {
    style: {
      maxHeight: media.matches.tablet.and('down') ? 'initial' : '300px',
      overflowY: 'auto',
      width: '100%',
      padding: '0'
    }
  }, media.matches.tablet.and('down') ? files.map(function (x, i) {
    return flexFile(x, i);
  }) : /*#__PURE__*/React.createElement(StyledTable, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null, t('signorder_field_file_type_label')), /*#__PURE__*/React.createElement("th", {
    style: {
      paddingLeft: '14px'
    }
  }, t('signorder_field_file_name_label')), /*#__PURE__*/React.createElement("th", null), /*#__PURE__*/React.createElement("th", null))), /*#__PURE__*/React.createElement("tbody", null, files.map(function (x, i) {
    return tableFileEl(x, i);
  })))))), /*#__PURE__*/React.createElement(Row, {
    marginBottom: "24px"
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Upload, {
    signOrderId: order.id
    // to remove
    ,
    fileUploadUrl: order.fileUploadUrl,
    toggleLoading: toggleLoading,
    isEmpty: documents.length === 0 && attachments.length === 0 && uploads.length === 0,
    allowedFileExtensions: (_order$uiFeatures = order.uiFeatures) === null || _order$uiFeatures === void 0 ? void 0 : _order$uiFeatures.validFileExtensions
  })))), /*#__PURE__*/React.createElement(Column, {
    style: {
      padding: 0
    }
  }, /*#__PURE__*/React.createElement(Segment, {
    outlined: true,
    marginBottom: "24px",
    divided: true,
    direction: media.matches.mobile.and('down') ? 'column' : 'row'
  }, /*#__PURE__*/React.createElement(Feature, {
    featureId: "signature_privatesignorder",
    onFeatureToggle: function onFeatureToggle(e) {
      return setPrivateOrderEnabled(e);
    }
  }, /*#__PURE__*/React.createElement(Toggle, {
    id: "make-private-toggle",
    label: t('signorder_make_private_toggle_label'),
    onChange: handleIsPrivateOrderChange,
    checked: isPrivateOrder,
    helpText: t('signorder_make_private_help_text'),
    disabled: !privateOrderEnabled || ['disabled_true', 'disabled_false'].includes(order.uiFeatures["private"])
  })), (userAndOrderGroups === null || userAndOrderGroups === void 0 ? void 0 : userAndOrderGroups.length) && /*#__PURE__*/React.createElement(Feature, {
    featureId: "core_userandgroupmanagement",
    onFeatureToggle: function onFeatureToggle(e) {
      return setOrderGroupsEnabled(e);
    },
    id: "restrict-to-groups-toggle"
  }, /*#__PURE__*/React.createElement(Field, {
    helpText: t('signorder_access_restrict_groups_help_text')
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: true,
    disabled: isPrivateOrder || !orderGroupsEnabled,
    options: userAndOrderGroups.map(function (group) {
      return {
        value: group.group,
        text: group.displayName
      };
    }),
    value: order.permissions.groups,
    onChange: handleGroupsChange,
    label: t('signorder_access_restrict_groups_label')
  })))), showPrivateWarning() ? /*#__PURE__*/React.createElement(Message, {
    variant: "info",
    icon: "info"
  }, t('signorder_admin_access_warning')) : null));
};
export default Content;